module.exports = __webpack_public_path__ + "static/Aston-20195_qtmg5r-5e01e80abe6176e75faac7fffb786a23.jpg";